import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { css } from '@emotion/react'
import { Button } from '@/components/atoms/button'
import { useAppSelector } from '@/app/hooks'
import { useNavigate } from 'react-router-dom'
import { Loading } from '@/components/organisms/loading'
import { CustomDesignStyle } from '@/components/template/custom-design-style'
import { NgImage, OkImage } from '@/components/atoms/icon'

export const CheckoutThanks: React.FC = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const { loading, checkoutResultHistories } = useAppSelector(state => state.checkout.checkoutData)
  const checkoutReservations = useAppSelector(state => state.checkout.checkoutReservation.checkoutReservations)

  const existsUnpaidReservation = useMemo(
    () => Object.values(checkoutResultHistories).some(isCompleted => !isCompleted),
    [checkoutResultHistories],
  )

  const isFrontSupported = useMemo(() => checkoutReservations?.some(reservation => reservation.frontSupported), [checkoutReservations])

  const isUsingSmartKey = useMemo(
    () => checkoutReservations?.length && !checkoutReservations.some(reservation => !reservation.isUsingSmartKey),
    [checkoutReservations],
  )

  console.log({
    isFrontSupported,
    isUsingSmartKey,
    existsUnpaidReservation,
  })

  return (
    <>
      <CustomDesignStyle />
      <div css={[layoutStyle]}>
        <Loading loading={loading}>
          {!existsUnpaidReservation && !isFrontSupported ? (
            <>
              <OkImage />
              <h2 css={thanksMessageStyle}>{t('Checkout is complete.')}</h2>
              <p css={leadStyle}>
                {t('Thank you for your stay.')}
                <br />
                {t(isUsingSmartKey ? 'Please have a safe trip home.' : 'Please return the key and leave.')}
              </p>
            </>
          ) : (
            <>
              <NgImage />
              <h2 css={thanksMessageStyle}>{t('Please complete the procedure\nat the front desk.')}</h2>
              {!isFrontSupported && (
                <p css={leadStyle}>
                  {t(
                    isUsingSmartKey
                      ? 'Please settle your account at the front desk.'
                      : 'Please return the key and settle your account at the front desk.',
                  )}
                </p>
              )}
            </>
          )}
          <Button buttonCss={buttonStyle} text={t('TOP')} onClick={() => navigate('/')} />
        </Loading>
      </div>
    </>
  )
}

const layoutStyle = css({
  display: 'flex',
  height: '100vh',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: '6rem',
  paddingRight: '1.5rem',
  paddingLeft: '1.5rem',
})

const thanksMessageStyle = css({
  fontSize: '22px',
  fontWeight: 'bold',
  marginTop: '2.5rem',
  marginBottom: '2rem',
  textAlign: 'center',
  lineHeight: '1.54',
  whiteSpace: 'pre-wrap',
})

const leadStyle = css({
  textAlign: 'center',
  fontSize: '14px',
  lineHeight: '1.4',
  whiteSpace: 'pre-wrap',
})

const buttonStyle = css({
  maxWidth: 568,
  marginTop: 'auto',
  marginBottom: '2.5rem',
})
